import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { RespectOrchestratorState } from "@nju/feature-portal-orchestrator";
import { CheckMigrationPossibilityPage } from "@nju/feature-portal-order";
import { BlockContent, LayoutWrapper } from "@nju/ui";
import { ClientSideOnly } from "../../components/ClientSideRenderer";

export default function CheckMigrationPossibility() {
  return (
    <LayoutWrapper>
      <Header />
      <BlockContent>
        <ClientSideOnly>
          <RespectOrchestratorState
            mode="mobile"
            refreshInterval={5000}
            state="LEGACY_FEASIBILITY_PENDING"
          >
            <CheckMigrationPossibilityPage />
          </RespectOrchestratorState>
        </ClientSideOnly>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
